import { object, string } from 'yup';

export const validator = object().shape({
  username: string()
    .required()
    .trim(),
  password: string().required(),
});
